<template>
  <v-card class="grey lighten-4 elevation-0">
    <v-card-text v-if="!fatalError">
      <v-container fluid>
        <form @submit.prevent.stop="submit" v-if="!submited">
          <v-layout row wrap>
            <v-flex xs12 md3 :class="isMobile ? 'my-3' : ''">
              <v-subheader>Identificação do aluno</v-subheader>
            </v-flex>
            <v-flex xs12 md9>
              <v-select label="Curso" v-model="exam.course" prepend-icon="class" disabled :items="courses"
                item-text="name" item-value="id"></v-select>
              <v-text-field label="Aluno" v-model="exam.studentName" readonly prepend-icon="subject"></v-text-field>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout row wrap>
            <v-flex xs12 md3 :class="isMobile ? 'my-3' : ''">
              <v-subheader>Informações do trabalho</v-subheader>
            </v-flex>
            <v-flex xs12 md9>
              <v-select label="Tipo" v-model="exam.type" prepend-icon="create" disabled :items="types" item-text="name"
                item-value="id"></v-select>
              <v-text-field label="Título" v-model="exam.title" readonly prepend-icon="title"></v-text-field>
              <!-- <v-text-field
                label="Tema"
                v-model="exam.topic"
                readonly
                prepend-icon="subject"
              ></v-text-field> -->
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout row wrap v-if="evaluator">
            <v-flex xs12 md3 :class="isMobile ? 'my-3' : ''">
              <v-subheader>Informações do avaliador</v-subheader>
            </v-flex>
            <v-flex xs12 md9>
              <v-text-field label="Avaliador" v-model="evaluatorName" readonly prepend-icon="person"></v-text-field>
              <v-text-field label="Início" v-model="evaluation.startDate" readonly
                prepend-icon="lock_open"></v-text-field>
              <v-text-field label="Término" v-model="evaluation.finishDate" readonly
                prepend-icon="lock_outline"></v-text-field>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout row wrap v-if="!evaluation.started && canEdit">
            <v-flex>
              <v-btn dark color="success" @click="startEvaluation">
                <v-icon left dark>start</v-icon> Iniciar avaliação
              </v-btn>
              <v-btn dark color="info" :to="{ path: '/bancas/avaliar' }">
                <v-icon left dark>undo</v-icon> Voltar
              </v-btn>
            </v-flex>
          </v-layout>
          <template v-if="evaluation.started">
            <v-layout row :class="isMobile ? 'my-3' : ''">
              <v-flex xs12 md8>
                <v-subheader class="title">Ficha de avaliação</v-subheader>
              </v-flex>
              <v-flex xs12 md2>
                <!-- <v-subheader class="body-2">Peso</v-subheader> -->
              </v-flex>
              <v-flex xs12 md2>
                <!-- <v-subheader class="body-2">Nota (0 a 10)</v-subheader> -->
              </v-flex>
            </v-layout>


            <!-- Versão antiga que funciona -->
            <!-- <template  v-if="canViewOrEditCriteria">
              <v-layout v-for="(criterion, idx) in orderedCriteria" :key="idx" row wrap :class="isMobile ? 'my-3' : 'mb-2'" align-center>
                <v-flex xs12 md8 :class="isMobile ? 'mb-1' : ''">
                  <span :class="['ml-' + (criterion.pos_ext.split('.').length)]">
                    <strong class="pr-2">{{ criterion.pos }}.</strong>
                    {{ criterion.description }}
                  </span>
                </v-flex>
                <v-flex xs12 md2 v-if="criterion.weight > 0">
                  <v-text-field label="Peso" v-model="criterion.weight" readonly disabled></v-text-field>
                </v-flex>
                <v-flex xs12 md2 v-if="criterion.leaf">
                  <v-text-field type="number" min="0" max="10" step="0.01" label="Nota" required v-validate="'required'"
                    v-model="evaluation.criteriaScores[criterion.id]" :readonly="evaluation.finished || !canEdit"
                    :tabindex="(idx + 1)" :append-icon="criterion.status == 'sent' ? 'cloud_done' : ''"
                    :loading="criterion.status == 'sending'" @change="submitCriterion(criterion, false)"></v-text-field>
                </v-flex>
              </v-layout>
              <v-divider class="mb-3"
                v-show="idx < (orderedCriteria.length - 1) && orderedCriteria[idx + 1].pos_ext.split('.').length == 1">
              </v-divider>
            </template> -->
            

            <template>
              <div v-if="canViewOrEditCriteria">
                <v-layout v-for="(criterion, idx) in orderedCriteria" :key="criterion.id || idx" row wrap
                  :class="isMobile ? 'my-3' : 'mb-2'" align-center>
                  <v-flex xs12 md8 :class="isMobile ? 'mb-1' : ''">
                    <span :class="['ml-' + (criterion.pos_ext.split('.').length)]">
                      <strong class="pr-2">{{ criterion.pos }}.</strong>
                      {{ criterion.description }}
                    </span>
                  </v-flex>
                  <v-flex xs12 md2 v-if="criterion.weight > 0">
                    <v-text-field label="Peso" v-model="criterion.weight" readonly disabled></v-text-field>
                  </v-flex>
                  <v-flex xs12 md2 v-if="criterion.leaf">
                    <v-text-field type="number" min="0" max="10" step="0.01" label="Nota" required
                      v-validate="'required'" v-model="evaluation.criteriaScores[criterion.id]"
                      :readonly="evaluation.finished || !canEdit" :tabindex="idx + 1"
                      :append-icon="criterion.status === 'sent' ? 'cloud_done' : ''"
                      :loading="criterion.status === 'sending'"
                      @change="submitCriterion(criterion, false)"></v-text-field>
                  </v-flex>
                  <v-divider class="mb-3"
                    v-show="idx < (orderedCriteria.length - 1) && orderedCriteria[idx + 1].pos_ext.split('.').length == 1">
                  </v-divider>
                </v-layout>
              </div>
            </template>



            <v-divider class="mb-3"></v-divider>
            <v-layout row class="mb-2">
              <v-flex xs12 md8>
                <v-subheader>
                  <span class="ml-1">
                    <strong class="pr-2">Nota final</strong>
                  </span>
                </v-subheader>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field label="Nota final" v-model="formattedFinalScore" :loading="loadingFinalScore"
                  readonly></v-text-field>
              </v-flex>
            </v-layout>
            <v-divider class="mb-3"></v-divider>
            <v-layout row>
              <v-flex xs12>
                <v-text-field label="Comentários" v-model="evaluation.notes" prepend-icon="rate_review" multi-line
                  auto-grow rows="3" :readonly="evaluation.finished || !canEdit" :tabindex="150"
                  :append-icon="notesStatus == 'sent' ? 'cloud_done' : ''" :loading="notesStatus == 'sending'"
                  @change="submitNotes(true)"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 text-xs-center>
                <v-alert color="warning" :value="vErrors.any()">
                  Preencha todos os campos do formulário para submeter sua avaliação, ou clique em <strong>Continuar
                    depois</strong>
                  para continuar a avaliação em outro momento.
                </v-alert>
                <v-alert color="error" :value="submitErrors.length > 0">
                  Ocorreram os seguintes erros na submissão do formulário:
                  <ul>
                    <li v-for="error in submitErrors" :key="error">{{ error }}</li>
                  </ul>
                </v-alert>
                <template v-if="!evaluation.finished && canEdit">
                  <v-btn dark color="info" @click="saveEvaluationData">
                    <v-icon left dark>save</v-icon> Continuar depois
                  </v-btn>
                  <v-btn dark type="submit" :disabled="vErrors.any()" light color="success">
                    <v-icon left dark>done</v-icon> Finalizar
                  </v-btn>
                </template>
                <v-alert color="info" :value="!evaluation.finished && !canEdit">
                  A avaliação ainda não foi finalizada.
                </v-alert>
                <v-alert color="success" :value="evaluation.finished">
                  A avaliação já foi finalizada.
                </v-alert>
              </v-flex>
            </v-layout>
          </template>
        </form>
        <v-layout row v-if="submited">
          <v-flex xs12>
            <v-card>
              <v-card-title class="green darken-1">
                <span class="white--text">Registro de avaliação enviado</span>
              </v-card-title>
              <v-card-text height="75px">
                <v-icon class="mr-4" dark>done</v-icon>
                A sua avaliação do trabalho foi <strong>{{ finishOk ? 'registrada e finalizada' : 'registrada'
                  }}</strong> com
                sucesso no sistema para a banca
                <v-chip class="green darken-1 white--text">
                  <router-link :to="{ name: 'examEvaluate', params: { id: exam.id } }">n.º {{ exam.id }}</router-link>
                </v-chip>.
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn dark color="success" :to="{ name: 'exams', params: { page: 1 } }">
                  <v-icon left dark>list</v-icon> Voltar para a lista
                </v-btn>
                <v-btn dark color="info" :to="{ name: 'bancas', params: { page: 1 } }">
                  <v-icon left dark>undo</v-icon> Voltar para as bancas
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-text v-else>
      <v-alert type="error" :value="fatalError" class="mt-5" outlined>
        {{ fatalError }}
      </v-alert>
      <v-btn color="primary" @click="goBack">
        <v-icon left>undo</v-icon> Voltar
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import ExamEvaluateMixin from './ExamEvaluateMixin'

export default {
  name: 'ExamEvaluateDetail',
  mixins: [ExamEvaluateMixin],
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly
    }
  }
}

</script>


<style scoped>
/* Estilos aqui */
</style>



// WEBPACK FOOTER //
// ExamEvaluateDetail.vue?c1cee192